import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import "./aiFormGenerator.css";
import TextAreaWithCount from "../../../components/input/new/textAreaWithCount";
import NarrowInputField from "../../../components/input/new/narrowInputField";
import NarrowDropdown2 from "../../../components/input/new/narrowDropdown2";

export default function AiFormGenerator({ open, onClose, onGenerate }) {
  const [description, setDescription] = useState("");
  const [formName, setFormName] = useState("");
  const [appointmentType, setAppointmentType] = useState("");
  const [requiredDocs, setRequiredDocs] = useState("");

  // Example appointment type options (replace with dynamic if needed)
  const appointmentTypeOptions = [
    { value: "", label: "Select appointment type" },
    { value: "Consultation", label: "Consultation" },
    { value: "Hearing", label: "Hearing" },
    { value: "Mediation", label: "Mediation" },
    // Add more as needed
  ];

  const handleGenerate = () => {
    onGenerate({ description, formName, appointmentType, requiredDocs });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: 0,
          boxShadow: "0 8px 32px rgba(20,74,140,0.10)",
        },
      }}
    >
      <div className="ai-form-generator-container">
        <div className="ai-form-header-row">
          <div className="ai-form-header-icon">
            {/* You can use an icon here */}
            <span className="ai-form-header-icon-inner">★</span>
          </div>
          <div>
            <div className="ai-form-header-title">AI Intake Form Generator</div>
            <div className="ai-form-header-desc">
              Describe the case. We will generate your intake form for you.
            </div>
          </div>
        </div>
        <div className="ai-form-section">
          <TextAreaWithCount
            label="Case Description"
            placeholder="Describe the situation this form is for (e.g., tenant facing eviction)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxChars={2000}
          />
          <div className="ai-form-desc">
            We'll use your description to generate a draft form you can
            customize.
          </div>
        </div>
        <div className="ai-form-section">
          <NarrowInputField
            title="Internal Form Name"
            subLabel="(Optional)"
            placeholder="e.g., Initial Consultation Intake Form"
            value={formName}
            onChange={(e) => setFormName(e.target.value)}
            isRequired={false}
          />
        </div>
        <div className="ai-form-section">
          <NarrowDropdown2
            title="Appointment Type"
            subLabel="(Optional)"
            placeholder="Select appointment type"
            items={appointmentTypeOptions}
            value={appointmentType}
            onChange={setAppointmentType}
            isRequired={false}
          />
        </div>
        <div className="ai-form-section">
          <NarrowInputField
            title="Required Documents"
            subLabel="(Optional)"
            placeholder="e.g., Lease Agreement, Termination Letter"
            value={requiredDocs}
            onChange={(e) => setRequiredDocs(e.target.value)}
            isRequired={false}
          />
        </div>
        <div className="ai-form-footer-row">
          <button className="ai-form-generate-btn" onClick={handleGenerate}>
            Generate
          </button>
        </div>
      </div>
    </Dialog>
  );
}
